import { useState } from 'react';
import useSurveyService from './userSurveyServices';
import { useSearchParams } from 'react-router-dom';

const useSurvey = () => {
    const { getSurveyQuestion, submitSurvey, getWhiteListData } = useSurveyService();

    const [searchParams] = useSearchParams();
    const queryUniqueId = searchParams.get('uniqueId');
  
    const [questions, setQuestions] = useState([]);
    const [displayMessage, setDisplayMessage] = useState('Employee Engagement Survey');
    const [bannerText, setBannerText] = useState('Please be as honest as possible! Responses will help the leadership team to identify gaps and focus on areas of potential we have as an employee-first organization.');
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [uniqueId, setUniqueId] = useState(queryUniqueId);

     const getWhiteListDataInt = async () => {
            var surveyResp = await getWhiteListData(uniqueId);
            console.log(displayMessage)
            console.log(isError);
            if(isError === false){
                setDisplayMessage(surveyResp?.data?.companyName + ' Employee Engagement Survey');
            }
        }
       

    async function getSurveyQuestionsForId(inputUniqueId, whiteListPage) {
        console.log('White List survey')
        console.log(whiteListPage)
        try {
            if(inputUniqueId !== undefined && inputUniqueId !== null && inputUniqueId !== ''){
                setIsError(true);
                if(whiteListPage === false){
                    setDisplayMessage('Employee Engagement Survey');
                }
                else {
                    await getWhiteListDataInt();
                }
                setBannerText('Please be as honest as possible! Responses will help the leadership team to identify gaps and focus on areas of potential we have as an employee-first organization.');
                setIsLoading(true);
                const questionResponse = await getSurveyQuestion(inputUniqueId); 
                const question = questionResponse.data;
                setQuestions(question.questions);
                setIsError(question.isError);
                if (question.isError) {
                    setDisplayMessage(question.displayMessage);
                }
            }

       }
        catch (error) {
            setIsError(true);
            setDisplayMessage(error.message);
            setQuestions([]);
        }
        finally {
            setIsLoading(false);
        }
    }

    async function submit(uniqieId, questions) {
        try {
            setIsError(true);
            setDisplayMessage('Survey Submitted');
            setIsLoading(true);
            await submitSurvey(uniqieId, questions);
            setQuestions([]);
        }
        catch (error) {
            setIsError(true);
            setDisplayMessage('Request failed. Please try back later');
            setQuestions([]);
        }
        finally {
            setIsLoading(false);
        }
    }

    return {
        uniqueId,
        setUniqueId,
        bannerText,
        questions,
        displayMessage,
        isLoading,
        isError,
        getSurveyQuestionsForId,
        setQuestions,
        submit,
        setDisplayMessage,
        getWhiteListData
    }

};

export default useSurvey;